import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProjectsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProjectsSettings.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { governanceProjectsConflictsRoute } from '@jira/router-routes__governance-projects-directory-routes/src/governanceProjectsConflictsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { globalPolicyConflictsPageEntryPoint } from '@jira/spa-apps__guided-autonomy-remediation/src/globalPolicyConflictsPageEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const globalPolicyConflictsPage = createPageEntryPoint({
	main: globalPolicyConflictsPageEntryPoint,
});

export const governanceProjectsConflictsRouteEntry: Route = createEntry(
	governanceProjectsConflictsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.governance-project-conflicts',
		layout: globalSettingsLayout,
		navigation: {
			sidebarId: SidebarIdGlobalProjectsSettings,
			menuId: MenuIdSettings,
		},
		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		entryPoint: () =>
			fg('guided_autonomy_remediation') ? globalPolicyConflictsPage : notFoundPageEntrypoint,
		meta: {
			reporting: {
				id: 'admin.governance-project-conflicts',
				packageName: 'jiraSpaAppsGuidedAutonomyRemediation',
				teamName: 'a4t-tanuki',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
